import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
import Theme from '../common/NekoTheme';

/**
 * @param {string} title=''
 */
const StyledNekoSettings = Styled(props => {
  const { title = '', contentAlign = 'left' } = props;
  return (
    <div className={props.className || ''}>
      {title ? <div className="nui-settings-head">{title}</div> : null}
      <div className={`nui-settings-content nui-settings-content-align-${contentAlign}`}>
        {props.children}
      </div>
    </div>
  );
})`
  display: flex;
  font-family: Lato, sans-serif;

  > .nui-settings-head {
    font-family: Lato;
    font-weight: bold;
    font-size: 14px;
    line-height: 17px;
    min-width: 120px;
    margin-right: 16px;
  }

  /* Select, Checkbox, Input need to be a bit higher to be in front of the settings title */

  .nui-settings-content > .nui-select:first-child {
    position: relative;
    margin-top: -5px;
  }
  
  .nui-settings-content > .nui-checkbox:first-child {
    position: relative;
    margin-top: -5px;
  }

  .nui-settings-content > .nui-input:first-child {
    position: relative;
    margin-top: -5px;
  }

  > .nui-settings-content {
    flex: 1;

    &.nui-settings-content-align-right {
      flex: none;
      margin-left: auto;
    }

    input[type=text] {
      width: 100%;
    }


  }

  & + div {
    margin-top: 15px;
  }
`;

const NekoSettings = (props) => {
  return (<StyledNekoSettings {...props} />);
}

NekoSettings.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string,
  contentAlign: PropTypes.string
};

NekoSettings.defaultProps = {
  title: '',
  className: undefined,
  contentAlign: 'left'
};

export { NekoSettings };
